<template>
  <div>
    <v-card class="overflow-hidden">
      <v-card-text>
        <v-row>
          <v-col>
            <item-autocomplete-filter
              :fatherEditedItem="filterSerialNumber"
              :editedItemIndex="-1"
              :itemName="'quotation_item_number'"
              @setEditedItem="setEditedItem"
            />
          </v-col>
          <v-col>
            <v-text-field
              :label="$t('quotation_item_serialnumber')"
              v-model="filterSerialNumber.Number"
              @input="getSerialNumber"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="serialNumberDataTableHeaders"
      :items="serialNumberList"
      class="elevation-1 my-5"
      :loading="isLoadingSerialNumber"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :server-items-length="totalRows"
      :options="currentOptions"
      @update:options="updateOptions"
      :header-props="headerProps"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>{{ $t('customer_tool_bar_title') }}</v-toolbar-title>
        </v-toolbar>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { HttpSerialNumber } from '@/js/http-Manager'
import axios from 'axios'
import ItemAutocompleteFilter from '@/components/ItemAutocompleteFilter.vue'

export default {
  components: { ItemAutocompleteFilter },
  name: 'Customer',
  data: () => ({
    serialNumberList: [],
    searchCustomer: '',
    isLoadingSerialNumber: true,
    updateItemSource: null,
    totalRows: 0,
    isUpdateEventTotal: true,
    currentOptions: {
      // default DataTable Options
      page: 1,
      itemsPerPage: 30,
      sortBy: [],
      sortDesc: [],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
      triggerByOutsite: true
    },
    serialNumberSomeSource: null,
    filterSerialNumber: {
      ItemId: '',
      ItemNumber: '',
      Number: ''
    }
  }),
  async mounted () {
    this.getSerialNumber()
    this.getTotalCount()
  },
  computed: {
    serialNumberDataTableHeaders () {
      return [
        {
          text: this.$t('item_number'),
          align: 'start',
          value: 'ItemNumber',
          sortable: false
        },
        {
          text: this.$t('item_name'),
          align: 'start',
          value: 'ItemName',
          sortable: false
        },
        {
          text: this.$t('engineer_stock_number'),
          align: 'start',
          value: 'StockNumber',
          sortable: false
        },
        {
          text: this.$t('engineer_stock_name'),
          align: 'start',
          value: 'StockName',
          sortable: false
        },
        { text: this.$t('quotation_item_serialnumber'), align: 'start', value: 'Number' },
        { text: this.$t('common_status'), align: 'start', value: 'IsUsed', sortable: false },
        {
          text: this.$t('serialnumber_acceptance_number'),
          align: 'start',
          value: 'AcceptanceNumber',
          sortable: false
        },
        {
          text: this.$t('serialnumber_repair_number'),
          align: 'start',
          value: 'RepairNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_customer_number'),
          align: 'start',
          value: 'CustomerNumber',
          sortable: false
        },
        {
          text: this.$t('quotation_shortname'),
          align: 'start',
          value: 'CustomerShortName',
          sortable: false
        },
        {
          text: this.$t('quotation_full_name'),
          align: 'start',
          value: 'CustomerFullName',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    }
  },
  methods: {
    async setEditedItem (val) {
      this.filterSerialNumber.ItemId = val.Id
      this.filterSerialNumber.ItemNumber = val.Number
      this.filterSerialNumber = JSON.parse(JSON.stringify(this.filterSerialNumber))
      await this.getTotalCount()
      await this.getSerialNumber()
    },
    async getTotalCount () {
      if (this.isUpdateEventTotal) {
        let param = {
          ItemId: this.filterSerialNumber.ItemId,
          number: this.filterSerialNumber.Number
        }
        let response = await HttpSerialNumber.GetSerialNumberCount(param)
        this.totalRows = response.status === 200 ? response.data.Data : 0
      }
    },
    updateOptions (val) {
      this.currentOptions = val
      this.isUpdateEventTotal = false
      this.getSerialNumber(val)
    },
    async getSerialNumber (val) {
      if (this.isUpdateEventTotal) {
        this.currentOptions.page = 1
        this.getTotalCount()
      }
      this.isUpdateEventTotal = true
      this.isLoadingSerialNumber = true
      let param = {
        ItemId: this.filterSerialNumber.ItemId,
        Number: this.filterSerialNumber.Number,
        PerPage:
          typeof val === 'object' && val ? val.itemsPerPage : this.currentOptions.itemsPerPage,
        Page: typeof val === 'object' && val ? val.page : this.currentOptions.page,
        SortBy: typeof val === 'object' && val ? val.sortBy[0] : this.currentOptions.sortBy[0],
        SortDesc: typeof val === 'object' && val ? val.sortDesc[0] : this.currentOptions.sortBy[0]
      }
      if (this.serialNumberSomeSource) {
        this.serialNumberSomeSource.cancel('cancel')
      }
      let cancelToken = axios.CancelToken
      this.serialNumberSomeSource = cancelToken.source()
      let response = await HttpSerialNumber.GetSerialNumbers(
        param,
        this.serialNumberSomeSource.token
      )
      this.isLoadingSerialNumber = false
      if (response) {
        this.serialNumberList = response.status === 200 ? response.data.Data : []
        this.serialNumberSomeSource = null
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    }
  }
}
</script>
